import React, {useEffect, useState} from 'react';
import {getCompanyInfo, updateProvideContactInfoMaxRating} from '../../../../../../../../services/company/api';
import SettingCard from '../../../../../../../../components-new/ui/SettingCard';
import ChoiceButtons from '../../../../../../../../components-new/form/ChoiceButtons';
import config from '../../../../../../../../config';

const ratingOptions = [1, 2, 3, 4, 5].map(value => ({label: String(value), value}));

export default function ContactInfoRatingSettings({client, addNotification}) {
    const [rating, setRating] = useState(3);
    const [loaded, setLoaded] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        let active = true;
        setLoaded(false);
        getCompanyInfo(client.id).then(data => {
            if (!active) return;
            const value = data && data.provideContactInfoMaxRating;
            setRating(Number.isInteger(value) && value >= 1 && value <= 5 ? value : 3);
            setLoaded(true);
        }).catch(() => {
            if (active) addNotification('contactInfoRatingLoadError', config.notificationLevels.error);
        });
        return () => { active = false; };
    }, [client.id]);

    const save = async value => {
        if (!loaded || saving || value === rating) return;
        setSaving(true);
        try {
            await updateProvideContactInfoMaxRating(client.id, value);
            setRating(value);
            addNotification('saved', config.notificationLevels.success);
        } catch (error) {
            addNotification('contactInfoRatingSaveError', config.notificationLevels.error);
        } finally {
            setSaving(false);
        }
    };

    return (
        <SettingCard titleKey="provideContactInfoMaxRating" hintKey="provideContactInfoMaxRatingHint">
            <div className="setting-body setting-body--compact">
                <div className="setting-field">
                    <ChoiceButtons value={rating} options={ratingOptions} onChange={save}
                                   disabled={!loaded || saving}/>
                </div>
            </div>
        </SettingCard>
    );
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/ContactInfoRatingSettings.jsx